// CreditLimitSection.tsx
import React from "react";
import SectionCard from "./SectionCard";
import Field from "./Field";
import { CreditLimitData } from "./types";

const input = "w-full border border-gray-200 rounded-lg px-3 py-2 text-sm";

interface Props {
  data: CreditLimitData;
  onChange: (data: CreditLimitData) => void;
}

export default function CreditLimitSection({ data, onChange }: Props) {
  const set = (key: keyof CreditLimitData, value: any) =>
    onChange({ ...data, [key]: value });

  return (
    <SectionCard step={1} title="Credit Limit Configuration">
      <div className="grid sm:grid-cols-2 gap-4">
        <Field label="Default Credit Limit (QAR)" hint="Default credit limit for new customers">
          <input
            className={input}
            type="number"
            value={data.defaultLimit}
            onChange={(e) => set("defaultLimit", Number(e.target.value))}
          />
        </Field>

        <Field label="Allow Credit for New Customers">
          <select
            className={input}
            value={data.allowNewCustomers ? "Yes" : "No"}
            onChange={(e) => set("allowNewCustomers", e.target.value === "Yes")}
          >
            <option>Yes</option>
            <option>No</option>
          </select>
        </Field>

        <Field label="Maximum Credit Limit (QAR)" hint="Maximum credit limit allowed for any customer">
          <input
            className={input}
            type="number"
            value={data.maxLimit}
            onChange={(e) => set("maxLimit", Number(e.target.value))}
          />
        </Field>

        <Field label="Low Balance Alert Threshold (%)" hint="Alert when outstanding reaches this % of credit limit">
          <input
            className={input}
            type="number"
            value={data.lowBalanceAlert}
            onChange={(e) => set("lowBalanceAlert", Number(e.target.value))}
          />
        </Field>
      </div>
    </SectionCard>
  );
}
